import React from 'react';
import Grid from '@mui/material/Grid';

import { useStyles } from './importantOutlook.styles';
import CommonImages from '../../commons/images/index';
import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';

function ImportantOutlook () {
    const classes = useStyles();
    const { translate, translateWithTags } = useTranslator();

    return (
        <Grid className={classes.container}>
            <img
                src={CommonImages.WARNING_TRIANGLE}
                className={classes.icon}
                alt="warning"
            />
            <Grid className={classes.textContent}>
                <span className={classes.title}>
                    { translate(TranslationIds.CALENDAR_GUIDE_WEBCAL_WARNING_TITLE) }
                </span>
                <span className={classes.message}>
                    { translateWithTags(
                        TranslationIds.CALENDAR_GUIDE_WEBCAL_WARNING_MESSAGE,
                        {
                            must: <span className={classes.must}>{ translate(TranslationIds.CALENDAR_GUIDE_MUST) }</span>,
                            webcal: <span className={classes.webcal}>webcal://</span>,
                        },
                    )}
                </span>
            </Grid>
        </Grid>
    );
}

export default ImportantOutlook;
